import { HttpClient } from '@angular/common/http';
import { TranslateLoader } from '@ngx-translate/core';
import { Observable, forkJoin, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

export class MultiTranslateHttpLoader implements TranslateLoader {
    constructor(
        private http: HttpClient,
        private prefix: string = './assets/i18n/',
        private suffix: string = '.json',
        private modules: string[] = ['shared', 'auth', 'header', 'sidebar', 'dashboard', 'clients', 'transactions', 'investigations', 'rfi', 'calculator', 'sessions', 'user_actions', 'settings', 'roles', 'business_info', 'new_va_account', 'add_transactions', 'notifications']
    ) { }

    public getTranslation(lang: string): Observable<any> {
        const requests = this.modules.map(module =>
            this.http.get(`${this.prefix}${lang}/${module}${this.suffix}`).pipe(
                catchError(() => of({}))
            )
        );

        return forkJoin(requests).pipe(
            map(responses => {
                let mergedTranslations: Record<string, any> = {};
                responses.forEach((response, index) => {
                    const moduleName = this.modules[index];
                    mergedTranslations[moduleName] = response;
                });
                return mergedTranslations;
            })
        );
    }
}
